import Mousetrap from './lib/component/Mousetrap';
import MousetrapMixin from './lib/mixin/Mousetrap';

export default Mousetrap;
export {
  MousetrapMixin
};



/** WEBPACK FOOTER **
 ** ./~/react-mousetrap-mixin/index.js
 **/